import {UmpireComponent} from '../umpire-component';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireImageOrientation} from '../umpire-image-orientation';
import {UmpireOttFormat} from '../umpire-ott-format';

export interface UmpireComponentOttFormatList
  extends UmpireComponent<UmpireComponentTypeEnum.OTT_FORMAT_LIST> {
  formats_order: FormatOrder[];
  auto_pick: boolean;
  is_featured: boolean;
  image_orientation: UmpireImageOrientation;
  formats?: UmpireOttFormat[];
  name: string;
}

export interface FormatOrder {
  format_id: string;
  format_index: number;
}
